import { REASONING_OPTIONS, reasoningShortLabelFor } from "./reasoningModes";

export const RESPONSE_LENGTHS = Object.freeze({
  FULL: "full",
  SHORT: "short",
});

export const RESPONSE_LENGTH_OPTIONS = Object.freeze([
  {
    value: RESPONSE_LENGTHS.SHORT,
    label: "Short",
    description: "Same analysis, concise answer",
  },
  {
    value: RESPONSE_LENGTHS.FULL,
    label: "Full",
    description: "Complete supporting detail",
  },
]);

export const normalizeResponseLength = (value) =>
  RESPONSE_LENGTH_OPTIONS.some((option) => option.value === value)
    ? value
    : RESPONSE_LENGTHS.FULL;

export const responseLengthForUser = (userData = {}) =>
  normalizeResponseLength(userData?.user_account_info?.response_length);

export const responseLengthPickerEnabledForUser = (userData = {}) =>
  Boolean(
    (userData?.has_premium_access ||
      userData?.has_active_subscription ||
      userData?.max_trial_active) &&
      userData?.user_account_info?.response_length_picker_enabled,
  );

export const responseLengthLabelFor = (value) =>
  RESPONSE_LENGTH_OPTIONS.find((option) => option.value === value)?.label ||
  RESPONSE_LENGTH_OPTIONS[1].label;

export const responseSettingsLabel = ({ responseLength, reasoningMode }) =>
  `${responseLengthLabelFor(responseLength)} · ${reasoningShortLabelFor(reasoningMode)}`;

export const persistResponseLength = async (responseLength) => {
  const response = await fetch("/graphql", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: `
        mutation ($responseLength: String!) {
          updateUserResponseLength(responseLength: $responseLength) {
            status
            responseLength
          }
        }
      `,
      variables: { responseLength },
    }),
  });
  const json = await response.json();
  const payload = json?.data?.updateUserResponseLength;
  if (!payload || payload.status !== "200") {
    throw new Error(json?.errors?.[0]?.message || "Save failed");
  }

  return normalizeResponseLength(payload.responseLength || responseLength);
};

export { REASONING_OPTIONS };
